export function splitObject(obj, parts) {
  const left = {};
  const right = {};
  Object.keys(obj).forEach((k) => {
    if (parts.indexOf(k) !== -1) {
      left[k] = obj[k];
    } else {
      right[k] = obj[k];
    }
  });
  return [left, right];
}

export function stopPropagation(e) {
  e.stopPropagation();
}



// WEBPACK FOOTER //
// ./src/js/_libs/rc-swipeout/utils.js